export const productHeaders = {
    CODE : ' Code',
    PRODUCT : 'Product ',
    CATEGORY : 'Category',
    WEIGHT : 'Weight',
    PURCHASE_PRICE : 'Purchase Price',
    SELLING_PRICE : 'Selling Price ',
    GST : 'GST %',
    TDS : 'TDS %'
}

export const productFields = {
    title : "Product Information",
    product_name : {
        title : "Product Name",
        placeholder :"Name"
    },
    product_code : {
        title : "Product Code",
        placeholder : "Code"
    },
    category : {
        title : "Category",
        placeholder : "Category"
    },
    weight : {
        title : "Weight",
        placeholder : "Weight"
    },
    dimension : {
        title : "Dimension",
        height : "Height",
        width : "Width",
        length : "Length"
    },
    gst : {
        title : "GST %",
        placeholder : "GST%"
    },
    tds : {
        title : "TDS %",
        placeholder :"TDS%"
    },
    gl_code : {
        title : "GL Code",
        placeholder :"GL Code"
    },
    purchase_information : "Purchase Information",
    sales_information : "Sales Information",
    purchase_amount : {
        title : "Purchase Price(INR)",
        placeholder : "Rs"
    },
    description : {
        title : "Description"
    },
    opening_stock : {
        title : "Opening Stock"
    },
    sellling_price : {
        title : "Selling Price(INR)",
        placeholder : "Rs"
    },
    reorder_level:{
        title :"Reorder Level"
    }

}
